import { render } from "./CourseTrainningStatistics.vue?vue&type=template&id=e79d6516&ts=true"
import script from "./CourseTrainningStatistics.vue?vue&type=script&lang=ts"
export * from "./CourseTrainningStatistics.vue?vue&type=script&lang=ts"

import "./CourseTrainningStatistics.vue?vue&type=style&index=0&id=e79d6516&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__